import script from "./IDiscountItem.vue?vue&type=script&setup=true&lang=js"
export * from "./IDiscountItem.vue?vue&type=script&setup=true&lang=js"

import "./IDiscountItem.vue?vue&type=style&index=0&id=15a65854&lang=scss"

const __exports__ = script;

export default __exports__